<template>
  <div class="Page">
    <HeaderSection 
      title="Contact"
      :closeLinkTo="{ name: 'home'}">
    </HeaderSection>
    <ContentSection>
      <SectionHeader label="Vragen?" />
      <p>
        Heeft u vragen over deze demonstratie?
      </p>
      <p>
        Neem gerust contact op via <a href="mailto:peter@derenovatieversneller.nl">peter@derenovatieversneller.nl</a>
      </p>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection'
import HeaderSection from '@/components/section/HeaderSection'
import SectionHeader from '@/components/section/Header'

export default {
  name: 'PageContact',
  components: {
    HeaderSection,
    ContentSection,
    SectionHeader
  }
}
</script>

<style lang="scss" scoped>
  a {
    color: $color_primary;

    &:hover {
      color: $metro_oranje;
    }
  } 
</style>

